import { render, staticRenderFns } from "./BaseMainLoader.vue?vue&type=template&id=af599362&"
import script from "./BaseMainLoader.vue?vue&type=script&lang=js&"
export * from "./BaseMainLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports